import { AssetDescription } from '@play-co/timestep-core';
import { arrayRandom } from '../../../lib/util/jsTools';
import {
  FireboxBlockEntity,
  spawnBlockEntity,
} from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { blockViewAssets } from '../../util/blockTools';
import { IEffect } from './IEffect';
import { blockPropsMap } from '../../defs/block';

// types
//-----------------------------------------------------------------------------
export type FireboxEffectOptions = {
  subject: FireboxBlockEntity;
};

/*
    firebox generates a random rocket or bomb
*/
export class FireboxEffect implements IEffect {
  // fields
  //-------------------------------------------------------------------------
  // input
  private readonly _scene: GameScene;
  private readonly _options: FireboxEffectOptions;

  // init
  //-------------------------------------------------------------------------
  constructor(scene: GameScene, options: FireboxEffectOptions) {
    this._scene = scene;
    this._options = options;
  }

  public static assets(): (string | AssetDescription<any>)[] {
    const assetsToLoad = [
      'bomb',
      'rocketHorizontal',
      'rocketVertical',
    ] as const;
    return assetsToLoad.map((id) => blockViewAssets(id)).flat();
  }

  // impl
  //-------------------------------------------------------------------------
  public async execute() {
    // spawn fire block
    await this._spawnFireBlock();
  }

  // private: actions
  //-------------------------------------------------------------------------
  private async _spawnFireBlock() {
    // Figure out which colors are available.
    const availableColors = this._scene.getSpawnListBasic().map((block) => {
      const blockProps = blockPropsMap[block];
      return 'color' in blockProps ? blockProps.color : null;
    });

    // Filter out objects that have a color property that is not in the available colors.
    const spawnList = this._options.subject.c.blockFirebox.spawnBlocks.filter(
      (x) => {
        const blockProps = blockPropsMap[x];
        return 'color' in blockProps
          ? availableColors.includes(blockProps.color)
          : true;
      },
    );

    // choose random spawn
    const id = arrayRandom(spawnList);

    // Nothing to spawn.
    if (!id) return;

    // spawn fire block
    spawnBlockEntity(
      this._scene,
      { id },
      this._options.subject.c.position.mapPosition,
    );
  }
}
